import Service from '@/utils/request';

/**
 * 农业作业需求相关接口（对齐 cloud-pilot-web AgriService 模块）
 * 路径前缀：/biz/agri/agriService
 *
 * 作业(服务)类型 serviceType：
 *   - plant_protection  植保
 *   - pest_inspection  病虫巡检
 *   - harvest          采收
 *
 * 状态 status：
 *   - draft       草稿
 *   - pending     待接单
 *   - accepted    已接单
 *   - executing   服务中
 *   - completed   已完成
 *   - cancelled   已取消
 */
const HomeworkApi = {
    /**
     * 查询农事作业需求列表
     * @param {AgriServiceQuery} query
     */
    listAgriService: (query) => Service.get('/biz/agri/agriService/list', { params: { ...query } }),

    /**
     * 查询农事作业需求各状态数量（用于 Tabs 计数）
     * @param {AgriServiceQuery} query
     */
    agriServiceStatusCount: (query) => Service.get('/biz/agri/agriService/statusCount', { params: { ...query } }),

    /**
     * 查询农事作业需求详细
     * @param {string|number} id
     */
    getAgriService: (id) => Service.get(`/biz/agri/agriService/${id}`, {}),

    /**
     * 新增农事作业需求
     * @param {AgriServiceForm} data
     */
    addAgriService: (data) => Service.post('/biz/agri/agriService', { ...data, appCode: 'NY' }),

    /**
     * 修改农事作业需求
     * @param {AgriServiceForm} data
     */
    updateAgriService: (data) => Service.put('/biz/agri/agriService', { ...data, appCode: 'NY' }),

    /**
     * 删除农事作业需求（支持单 id 或 id 数组）
     * @param {string|number|string[]|number[]} id
     */
    delAgriService: (id) => Service.delete(`/biz/agri/agriService/${id}`, {}),

    /**
     * 创建作业需求飞行任务
     * @param {AgriServiceCreateTaskForm} data
     */
    createAgriServiceTask: (data) => Service.post('/biz/agri/agriService/createTask', { ...data }),

    /**
     * 导出农事作业需求
     * @param {AgriServiceQuery} query
     */
    exportAgriService: (query) => Service.get('/biz/agri/agriService/export', { params: { ...query }, responseType: 'blob' }),
};

export default HomeworkApi;
